/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerParentProjection
 */
export interface PartnerParentProjection {
    /**
     * 
     * @type {number}
     * @memberof PartnerParentProjection
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerParentProjection
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerParentProjection
     */
    siret: string;
}

/**
 * Check if a given object implements the PartnerParentProjection interface.
 */
export function instanceOfPartnerParentProjection(value: object): value is PartnerParentProjection {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('siret' in value) || value['siret'] === undefined) return false;
    return true;
}

export function PartnerParentProjectionFromJSON(json: any): PartnerParentProjection {
    return PartnerParentProjectionFromJSONTyped(json, false);
}

export function PartnerParentProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerParentProjection {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'siret': json['siret'],
    };
}

export function PartnerParentProjectionToJSON(json: any): PartnerParentProjection {
    return PartnerParentProjectionToJSONTyped(json, false);
}

export function PartnerParentProjectionToJSONTyped(value?: PartnerParentProjection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'siret': value['siret'],
    };
}

